<div class="ted-button-wrap" (click)="onClick()">
  <div class="ted-icon-wrap">
    <g99-icon-btn
      [icon]="tedIcon"
      [height]="22"
      [width]="22"
      [padding]="0"
      [backgroundColor]="'transparent'"
      [colorStrategy]="'none'"
      [isDisabled]="false"
      [isLoading]="false"
    />
    <span class="ted-label">TED</span>
  </div>
</div>
